import { Injectable, Inject } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { AppTranslationService } from "../services/app-translation.service";

@Injectable()
export class MatPaginatorHandler extends MatPaginatorIntl {
    private translate: AppTranslationService;
    itemsPerPageLabel = 'Items per page';
    nextPageLabel = 'Next page';
    previousPageLabel = 'Previous page';

    constructor(
        @Inject(AppTranslationService) translate: AppTranslationService) {
        super();
        this.translate = translate;

        this.translateLabels();

    }
    
    translateLabels() {
        this.itemsPerPageLabel = this.translate.getTranslation('paginator.items_per_page');
        this.nextPageLabel = this.translate.getTranslation('paginator.next_page');
        this.previousPageLabel = this.translate.getTranslation('paginator.previous_page');
    }

    getRangeLabel = function (page, pageSize, length) {
        const of = this.translate ? this.translate.getTranslation('paginator.of') : 'of';
        if (length === 0 || pageSize === 0) {
            return '0 ' + of + ' ' + length;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        // If the start index exceeds the list length, do not try and fix the end index to the end.
        const endIndex = startIndex < length ?
            Math.min(startIndex + pageSize, length) :
            startIndex + pageSize;
        return startIndex + 1 + ' - ' + endIndex + ' ' + of + ' ' + length;
    };}
